import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/common.css'
import './style/pdf.scss'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueSuperSlide from 'vue-superslide'
Vue.use(VueSuperSlide)
Vue.use(Element)
Vue.config.productionTip = false

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer, {
  defaultOptions: {
    navbar: false,
    title: false,
    toolbar: true,
    movable: false
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
